import {Component, inject, OnInit} from '@angular/core'
import {ENVIRONMENT} from '../../application/constants'
import {ConfigService} from '../../services/config.service'
import {BankIdComponent} from '@framfab/framfab-bankid-fe'
import {environment} from '../../../environments/environment'
import {filter, first} from 'rxjs'
import {Router} from '@angular/router'


@Component({
  selector: 'ffs-login',
  imports: [
    BankIdComponent
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  providers: [
    {provide: ENVIRONMENT, useValue: environment}
  ]
})
export class LoginComponent implements OnInit {
  protected readonly environment = inject(ENVIRONMENT)

  public service = inject(ConfigService)

  private router = inject(Router)

  public ngOnInit(): void {
    this.service.accessToken$.pipe(
      filter(Boolean),
      first()
    ).subscribe({
      next: () => this.router.navigate(['/', 'list'])
    })
  }
}
